import React from "react";

const Java_Syntax = () => {
  return (
    <div>
      <h1>Java Syntax</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Syntax in Java.</p>
    </div>
  );
};

export default Java_Syntax;
